const items = [
  { text: 'News', href: '/news' },
  { text: 'Find pet', href: '/notices' },
  { text: 'Our friends', href: '/friends' },
];

export default items;
